module.exports = __webpack_public_path__ + "static/media/journey-thumb.a5bae3f6.jpg";